module.exports = __webpack_public_path__ + "static/wky.47e3b7fe.png";